import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useNamespacedTranslation } from './useNamespacedTranslation';

export const useUnsavedChanges = (isDirty: boolean) => {
  const history = useHistory();
  const t = useNamespacedTranslation('general');

  useEffect(() => {
    if (!isDirty) {
      return;
    }

    const unblock = history.block((location, action) => {
      const message = t('leavePageWithoutUnsafeChanges');
      return window.confirm(message) ? undefined : false;
    });

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty, history, t]);
};
